import { Heading, VStack } from '@chakra-ui/react';
import type { LiveMatch } from '@/models/liveMatch';
import { sortLiveMatchesByRecency } from '@/helpers/fixtures/liveMatchDisplay';
import { LiveMatchRow, liveMatchBracketLabel } from './LiveMatchRow';

export function LiveMatchesList(props: { liveMatches: LiveMatch[]; svg?: boolean; showHeading?: boolean }) {
  if (props.liveMatches.length === 0) {
    return null;
  }

  const sorted = sortLiveMatchesByRecency(props.liveMatches);

  return (
    <VStack align='stretch' spacing={2} w='full'>
      {props.showHeading && sorted.length > 1 ? (
        <Heading fontSize='sm' fontWeight='semibold'>
          Live now
        </Heading>
      ) : null}
      {sorted.map((liveMatch) => {
        const bracketLabel = liveMatchBracketLabel(liveMatch);
        return (
          <LiveMatchRow
            key={liveMatch.matchId}
            liveMatch={liveMatch}
            svg={props.svg}
            showBracketLabel={Boolean(bracketLabel)}
            bracketLabel={bracketLabel}
          />
        );
      })}
    </VStack>
  );
}
